exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".error.error-6 .error-title {\n  font-size: 5rem !important;\n}\n\n@media (min-width: 768px) {\n  .error.error-6 .error-title {\n    font-size: 10rem !important;\n  }\n}", ""]);

